import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button } from "semantic-ui-react";
import { DuplicateDraftWindow } from "../utils";

export const CopyButton = ({ draft, draftId, disabled }) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    setModalOpen(true);
  };

  return (
    <>
      <Button
        color="green"
        fluid
        onClick={handleClick}
        disabled={true}
        // disabled={disabled ?? false}
      >
        Copy
      </Button>
      {isModalOpen && (
        <DuplicateDraftWindow
          draft={draft}
          draftId={draftId}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
};

CopyButton.propTypes = {
  draft: PropTypes.object,
  draftId: PropTypes.string,
  disabled: PropTypes.bool,
};
